import React from "react";
import { Text, Button, Flex } from "@mantine/core";
import Item from "./Item";

export default function ConfirmProfiles({
  profiles,
  onBackClick,
  onSubmit,
  loading,
}) {
  return (
    <div>
      <Text fw={700}>Confirm the following profiles</Text>
      <div className="profile-items">
        {profiles
          .sort((a, b) => (a.original_name > b.original_name ? 1 : -1))
          .map((profile) => (
            <Item
              key={profile.id}
              name={profile.original_name}
              profile={profile}
              tags={profile.tags}
            />
          ))}
      </div>
      <Flex gap="xs" align="center">
        <Button
          variant="light"
          onClick={onBackClick}
          disabled={loading}
          color="gray"
        >
          Back
        </Button>
        <Button
          color="green"
          variant="light"
          onClick={onSubmit}
          loading={loading}
        >
          Confirm
        </Button>
      </Flex>
    </div>
  );
}

ConfirmProfiles.defaultProps = {
  profiles: [],
  loading: false,
};
